<template>
  <el-container v-if="show" id="mainModule-container" direction="vertical">
    <!-- 页面 body -->
    <el-main id="mainModule-main">
      <router-view />
    </el-main>
    <!-- 页面顶部 -->
    <el-header id="mainModule-header" height="64px">
      <v-head />
    </el-header>
  </el-container>
</template>

<script>
import vHead from 'src/components/Header.vue'
import {mapGetters} from 'vuex'

export default {
  components: {
    vHead,
  },
  data() {
    return {
      show: false,
      interval: null,
    }
  },
  computed: {
    ...mapGetters(['isAdmin', 'accountInfo']),
  },
  async mounted() {
    // await this._checkAuthorize()
    this.show = true
  },
  destroyed() {
    clearInterval(this.interval)
  },
  methods: {
    async _checkAuthorize() {
      await new Promise(resolve => {
        this.interval = setInterval(() => {
          if (
            this.accountInfo.statusInfo &&
            this.accountInfo.statusInfo.level === 1
          ) {
            clearInterval(this.interval)
            resolve()
          }
        }, 100)
      })
    },
  },
}
</script>

<style lang="scss">
#mainModule-container {
  position: relative;
  display: flex;
  height: 100%;
  flex-direction: column-reverse;

  #mainModule-header {
    /*position: relative;*/
    /*z-index: 1;*/
  }

  #mainModule-main {
    flex: 1;
    display: flex;
  }
}
</style>
